import logo from '../../assets/images/resource/sidebar-logo.png'
import logonew from '../../assets/images/logo.png'
import imgone from '../../assets/images/resource/menu-image-1.jpg'
import imgtwo from '../../assets/images/resource/menu-image-2.jpg'
import Imgthree from '../../assets/images/resource/menu-image-3.jpg'
import Imgfour from '../../assets/images/resource/menu-image-4.jpg'
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Main() {

    const location = useLocation();
    const [active, setActive] = useState();
    const [lastscrool, setlastscrool] = useState(0);

    const [scrolled, setScrolled] = useState(false);
    const [Nav, setNav] = useState(true);

    const handleScroll = () => {

        const offset = window.scrollY;
        setlastscrool(offset);

        if (offset > 1000 && offset < lastscrool) {
            setNav(true);
            setScrolled(true);
        }

        else if (offset > 1000) {
            setNav(false)
        }

        else if (offset > 200) {
            setNav(true);
            setScrolled(true);
        }

        else {
            setScrolled(false);
            setNav(true);
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll)
    })

    return (
        <>
            {active &&
                <div className="menu-backdrop" style={{ opacity: "1", visibility: "visible" }}></div>
            }
            <section className={`hidden-bar ${active && "visible-sidebar"}`} >
                <div className="inner-box">
                    <div className="cross-icon hidden-bar-closer" onClick={() => setActive(false)} ><span className="far fa-close" onClick={() => setActive(false)} > </span></div>
                    <div className="logo-box"><Link to="/" title=   "BonAppetit"><img src={logo} alt="" title="BonAppetit" />
                    </Link></div>

                    <div className="side-menu">
                        <ul className="navigation clearfix">
                            <li className={location.pathname === '/' ? 'current' : ''}><Link to="/" onClick={() => setActive(false)}>Početna</Link></li>
                            <li className={location.pathname === '/menu' ? 'current' : ''}><Link to="/menu" onClick={() => setActive(false)}>Meni</Link></li>
                            <li className={location.pathname === '/about' ? 'current' : ''}><Link to="/about" onClick={() => setActive(false)}>O nama</Link></li>
                            <li className={location.pathname === '/contact' ? 'current' : ''}><Link to="/contact" onClick={() => setActive(false)}>Kontakt</Link></li>
                        </ul>
                    </div>

                    <h2>Posetite nas</h2>
                    <ul className="info">
                        <li>Ivana Gundulića 7, <br /> Smederevo 230437 </li>
                        <li>Radno vreme: 08:00 - 22:30</li>
                    </ul>
                    <div className="separator"><span></span></div>
                    <div className="booking-info">
                        <div className="bk-title">Poručite na broj</div>
                        <div className="bk-no"><Link to="tel:+381 64 1856 290">+381 64 1856 290</Link></div>
                    </div>

                </div>
            </section>
            {Nav &&
                <header className={`main-header ${scrolled && "fixed-header"} header-down`}>
                    <div className="header-top">
                        <div className="auto-container">
                            <div className="inner clearfix">
                                <div className="top-left clearfix">
                                    <ul className="top-info clearfix">
                                        <li><i className="icon far fa-map-marker-alt"></i> Ivana Gundulića 7, Smederevo 230437</li>
                                        <li><i className="icon far fa-clock"></i> Radno vreme : 08:00 - 22:30</li>
                                    </ul>
                                </div>
                                <div className="top-right clearfix">
                                    <ul className="top-info clearfix">
                                        <li><Link to="tel:+11234567890"><i className="icon far fa-phone"></i> +381 64 1856 290 </Link> </li>
                                        <li><a href="https://glovoapp.com/rs/en/smederevo/bon-appetit-smd/" target="_blank" rel="noopener noreferrer">Glovo</a></li>
                                        <li><a href="https://wolt.com/sr/srb/smederevo/restaurant/bon-appetit-smederevo?srsltid=AfmBOoqrxFzCZCweBtLFJjMRJEOyTajPItBmoEv6whAbOqG2XbhA_dsD" target="_blank" rel="noopener noreferrer">Wolt</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="header-upper header-fixed" >
                        <div className="auto-container">
                            <div className="main-box d-flex justify-content-between align-items-center flex-wrap">

                                <div className="links-box clearfix">
                                    <div className="nav-toggler">
                                        <button className="hidden-bar-opener">
                                            <span className="hamburger" onClick={() => setActive(true)}>
                                                <span className="top-bun"></span>
                                                <span className="meat"></span>
                                                <span className="bottom-bun"></span>
                                            </span>
                                        </button>
                                    </div>
                                </div>

                                <div className="logo-box">
                                    <div className="logo"><Link to="/" title="BonAppetit"><img src={logonew} alt="" title="BonAppetit" /></Link></div>
                                </div>

                                <div className="nav-box clearfix">

                                    <div className="nav-outer clearfix">
                                        <nav className="main-menu">
                                            <ul className="navigation clearfix">
                                                <li className={location.pathname === '/' ? 'current' : ''}><Link to="/">Početna</Link></li>
                                                <li className={`dropdown has-mega-menu ${location.pathname.includes('/menu') ? 'current' : ''}`}><Link to="/menu">Menus</Link>
                                                    <ul>
                                                        <li>
                                                            <div className="mega-menu">
                                                                <div className="menu-inner">
                                                                    <div className="auto-container">
                                                                        <div className="row clearfix">
                                                                            <div className="menu-block col-lg-3 col-md-6 col-sm-6">
                                                                                <div className="image"><Link to="/menuone"><img src={imgone} alt="" /></Link></div>
                                                                                <div className="title"><Link to="/menuone">Menu list 1</Link></div>
                                                                            </div>
                                                                            <div className="menu-block col-lg-3 col-md-6 col-sm-6">
                                                                                <div className="image"><Link to="/menutwo"><img src={imgtwo} alt="" /></Link></div>
                                                                                <div className="title"><Link to="menutwo">Menu list 2</Link></div>
                                                                            </div>
                                                                            <div className="menu-block col-lg-3 col-md-6 col-sm-6">
                                                                                <div className="image"><Link to="/menu"><img src={Imgthree} alt="" /></Link></div>
                                                                                <div className="title"><Link to="/menu">Menu list 3</Link></div>
                                                                            </div>
                                                                            <div className="menu-block col-lg-3 col-md-6 col-sm-6">
                                                                                <div className="image"><Link to="/menufour"><img src={Imgfour} alt="" /></Link></div>
                                                                                <div className="title"><Link to="/menufour">Menu list 4</Link></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li className={location.pathname === '/about' ? 'current' : ''}><Link to="/about">O nama</Link></li>

                                                <li className={location.pathname === '#' ? 'current' : ''}><Link to="#">Blog</Link></li>
                                                <li className={location.pathname === '/contact' ? 'current' : ''}><Link to="/contact">Kontakt</Link></li>
                                            </ul>
                                        </nav>
                                    </div>

                                </div>

                                {/* <div className="link link-btn">
                                    <Link to="/reservation" className="theme-btn btn-style-one clearfix">
                                        <span className="btn-wrap">
                                            <span className="text-one">find a table</span>
                                            <span className="text-two">find a table</span>
                                        </span>
                                    </Link>
                                </div> */}

                            </div>
                        </div>
                    </div>
                </header>
            }
        </>
    )
}

export default Main